import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal'
import Style from '../Styles/DashboardStyle.module.css';
import { Link,useNavigate  } from 'react-router-dom';
import DashboardTitle from "./DashboardTitle";
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
import CustomModal from './CustomModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getJobsListIdFormData,getUserJobsListFormData ,getJobsDeleteFormData} from "../../services/routes.services";
import constants from "../../services/constants";
import { IoMdClose } from "react-icons/io";
const JobListing = ()=>{
    const [show, setShow] = useState(false);
    const [getDetails, setDetails] = useState(null);
    const [jobData, setJobData] = useState();
    const [skillsArray, setSkillsArray] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState(false);
    const navigate = useNavigate();
    const { isAuthenticated, user,token } = useSelector((state) => state.auth);
  
    const handleOpen = (data) => {
        setModalData(data)
      setModalOpen(true);
    };
  
    const handleDeleteClose = () => {
      setModalOpen(false);
    };
  
    const handleConfirm = (data) => {
          getJobsDeleteFormData(data._id,token)
      .then((res) => {
        if(res.status===200){
        toast.success(res.data.message, {
               position: "top-right",
                
            type: 'success'
        });
        JobListingApi();
    }else{
        toast.error(res.data.message, {
            position: "top-right",
               type: 'error'
         });
    }
           })
      .catch((error) => {
          console.log(error);
      });
      setModalOpen(false);
    };
    const handleClose = () => {
        setShow(false);
        setDetails(null)
    }
   
    const handleShow = (Busnisslist) => {
        setShow(true);
        getJobsListIdFormData(Busnisslist._id)
            .then((res) => {
                setDetails(res.data);
                setSkillsArray(res.data.job.skills);
               console.log()
            })
            .catch((error) => {
                console.log(error);
            });
    }
   
    useEffect(() => {
        JobListingApi()
            
            
    }, []);
    const JobListingApi=()=>{
        getUserJobsListFormData(token)
            .then((res) => {
                setJobData(res.data.job);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    
    const handleEditPage=(JobDetails)=>{
        navigate("/myjobs", { state: { jobDetails: JobDetails } });
    }
    return( 
        <div><DashBoardLeftProfileMenu/>
         <div className={'containerStyla  ' + Style.Dashboardscreen +" "+Style.BussinesList}>
            <Container>
                <DashboardTitle title="JOB LISTINGS" membertype="Non Member" />
                <Row className={Style.space}>
            <Col lg={6} className={Style.order2}>
                <h3 className={Style.dashboardSubTitle}>Add New Job Post</h3>
                {jobData &&(<>
                {jobData.map((JobDetails)=>{
                    return(
                        <div className={Style.jobList} key={JobDetails._id}>
                        <figure><img src={constants.IMAGE_BASE_URL+'business/'+JobDetails.image} alt="" /></figure>
                        {JobDetails.jobType && (<h4> {JobDetails.jobType}</h4>)}
                            {JobDetails.companyName && (<p> {JobDetails.companyName}</p>)}
                            {JobDetails.jobRole && (<span> {JobDetails.jobRole}</span>)}
                        
                            <ul>
                                <li><a href="#" onClick={(e) => {e.preventDefault();handleShow(JobDetails)}} className={Style.discountBtn} title="More Detail">More Details</a></li>
                                <li><a href="#" onClick={(e) => {e.preventDefault();handleEditPage(JobDetails)}}>Edit</a></li>
                                <li><a href="#" onClick={(e) => {e.preventDefault();handleOpen(JobDetails)}}>Delete Listing</a>
                                        <CustomModal
                                            open={modalOpen}
                                            handleDeleteClose={handleDeleteClose}
                                            handleConfirm={()=>handleConfirm(modalData)}
                                            title="Confirm Action"
                                            jobData={modalData}
                                            description="Are you sure you want to perform this action?"
                                        />                          
                                            </li>
                            </ul>                    
                    </div> 
                    )
                }) }
                 </>)}
              
            </Col>
            <Col lg={6} className={Style.paddL + " " + Style.order1}>
                <div className={Style.addJobList}>
                    <h4>Create New Post</h4>
                    <Link to="/myjobs" className={Style.greenBtn} >Click Here</Link>
                </div>
            </Col>
            </Row>
            {show &&
                <div className={Style.popOverlay}>
                    <div className={Style.discountPopup}>
                        <button type="button" className={Style.closePopup} onClick={handleClose}><IoMdClose /></button>
                        {getDetails &&
                        
                           
                                <div className={Style.discountDetails}>
                                <div className={Style.companyLogo}>
                                        <img src={constants.IMAGE_BASE_URL+'business/'+getDetails.job[0].image} />
                                </div>
                                <div className={Style.offerHead}>
                                {getDetails.jobtype.map(jobdata=>{
                                                                if(getDetails.job[0].jobType===jobdata._id){
                                                                return(
                                                                    <h2 key={jobdata._id}>
                                                                    {jobdata.name}
                                                                </h2>
                                                                )}
                                                               }) }
                                    
                                    <p>
                                    {getDetails.job[0].jobRole}
                                    </p>
                                </div>
                               
                                <div className={Style.offerDetails}>
                                    <table role="none">
                                        <tbody><tr>
                                            <td className={Style.left}>Business Name</td>
                                            <td className={Style.right}>{getDetails.job[0].company}</td>
                                        </tr>
                                        <tr>
                                            <td className={Style.left}>Category</td>
                                            <td className={Style.right}>{getDetails.job[0].category}</td>
                                        </tr>
                                        
                                        <tr>
                                            <td className={Style.left}>Business Contact No.</td>
                                            <td className={Style.right}> {getDetails.job[0].phone}</td>
                                        </tr>
                                        <tr>
                                            <td className={Style.left}>CITY</td>
                                            <td className={Style.right}>{getDetails.job[0].city} </td>
                                        </tr>
                                        <tr>
                                            <td className={Style.left}>Experience</td>
                                            <td className={Style.right}>{getDetails.job[0].experience}</td>
                                        </tr>
                                        <tr>
                                            <td className={Style.left}>Website</td>
                                            <td className={Style.right}>{getDetails.job[0].website}</td>
                                        </tr>
                                        <tr>
                                            <td className={Style.left}>Skills</td>
                                            <td className={Style.right}>
                                                       {getDetails.job[0].skills}
                                                    </td>
                                        </tr>

                                        <tr>
                                            <td className={Style.left}>Description</td>
                                            <td className={Style.right}>{getDetails.job[0].description}</td>
                                        </tr>
                                        <tr>
                                            <td className={Style.left}>Posted By Name</td>
                                            <td className={Style.right}>{getDetails.job[0].postedBy}</td>
                                        </tr>
                                        <tr>
                                            <td className={Style.left}>Designation</td>
                                            <td className={Style.right}>{getDetails.job[0].designation}</td>
                                        </tr>
                                        <tr>
                                            <td className={Style.left}>Batch</td>
                                            <td className={Style.right}>{getDetails.job[0].batch}</td>
                                        </tr>
                                    </tbody></table>
                                </div>
                                <a href="#" onClick={(e) => {e.preventDefault();handleEditPage(getDetails.job)}} className={Style.greenBtn}>Edit</a>
                                </div>
                           
                          
                          
                        }
                    </div>
                </div>
            }
                            <ToastContainer />
            </Container>
        </div>
      
        </div>
        )
    }
    
    export default JobListing;